import { BusinessObjectBase } from './base';
import type { Candidate } from './candidate';

export interface EmergencyContactData {
  readonly id: number;
  readonly name?: string;
  readonly phoneNumber?: string;
  readonly relationship?: string;
  readonly candidateId: number;
  readonly candidate?: Candidate;
}

export interface EmergencyContact extends Readonly<EmergencyContactData> {}
export class EmergencyContact extends BusinessObjectBase {
  static readonly entityName = 'EmergencyContact' as const;
  static readonly plural = 'emergency-contacts';

  // --- Static CRUD methods ---

  static async find(filter?: any): Promise<EmergencyContact[]> {
    const url = `${this.baseUrl}/${this.plural}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const results = await this.get<any[]>(url, params);
    return results.map((data) => new EmergencyContact(data));
  }

  static async findOne(filter?: any): Promise<EmergencyContact | null> {
    const url = `${this.baseUrl}/${this.plural}/find-one`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return data ? new EmergencyContact(data) : null;
  }

  static async findById(id: number, filter?: any): Promise<EmergencyContact> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return new EmergencyContact(data);
  }

  static async create(
    data: Omit<EmergencyContactData, 'id'>,
  ): Promise<EmergencyContact> {
    const url = `${this.baseUrl}/${this.plural}`;
    const result = await this.post<any>(url, data);
    return new EmergencyContact(result);
  }

  static async updateById(
    id: number,
    data: Partial<EmergencyContactData>,
  ): Promise<EmergencyContact> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const result = await this.patch<any>(url, data);
    return new EmergencyContact(result);
  }

  static async deleteById(id: number): Promise<boolean> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    try {
      await this.del<void>(url);
      return true;
    } catch {
      return false;
    }
  }
}
